<template>
    <div class="dataConsult">
        <div
            class="dataConsult-desc"
            :style="{ backgroundImage: `url(${$imageSrcMap.introduction.bg})` }"
        >
            <h1> {{ textObj.title }} </h1>
            <p>{{ textObj.content }}</p>
            <dsh-buttons
                class="customizeModal-btn"
                :list="$getOperationList(['openModal'])"
                @click="$dispatchEvent($event)"
            ></dsh-buttons>
            <customize-modal
                v-if="showApplyModal"
                source="customized"
                :showApplyModal="showApplyModal"
                :priFormData="priFormData"
                @closeModalFunc="showApplyModal = false"
            ></customize-modal>

            <img :src="textObj.mainImg" />
        </div>

        <div
            class="dataConsult-difficult introduce-container"
            style="padding-top: 228px;"
        >
            <h3 class="apaasCloud-title"> {{ textObj.subTitle }} </h3>
            <Row
                class="dataConsult-difficult-content"
                type="flex"
            >
                <Col
                    v-for="(col, colIndex) in textObj.row"
                    span="8"
                    :key="colIndex"
                >
                <div :style="{'margin-bottom': colIndex<3?'50px':''}">
                    <img
                        :src="col.icon"
                        :alt="col.name"
                    >
                    <p>{{ col.name }}</p>
                </div>
                </Col>
            </Row>
        </div>

        <div
            class="dataConsult-solu introduce-container"
            style="padding-bottom: 0; position: relative;"
        >
            <h3 class="apaasCloud-title"> {{ textObj.brightText }} </h3>
            <div class="dataConsult-solu-container">
                <swiper
                    class="swiper-wrapper"
                    :options="swiperOption"
                    ref="mySwiper"
                >
                    <swiper-slide
                        :style="{background: index%2===0?'#EFFBFA':'#F4FCFE'}"
                        v-for="(brightItem, index) in textObj.bright"
                        :key="index"
                    >
                        <div class="scroll-item">
                            <div class="scroll-item-info">
                                <img
                                    :src="brightItem.icon"
                                    :alt="brightItem.name"
                                >
                                <h3
                                    class="apaasCloud-title title-grey"
                                    style="text-align: left;"
                                >{{ brightItem.name }}</h3>
                                <p>{{ brightItem.text }}</p>
                            </div>
                            <img
                                class="scroll-item-pic"
                                :src="brightItem.image"
                            />
                        </div>
                    </swiper-slide>
                    <div
                        class="swiper-pagination"
                        slot="pagination"
                    ></div>
                </swiper>
            </div>
        </div>

        <div
            class="dataConsult-partner introduce-container"
            style="padding-bottom: 230px;"
        >
            <h3 class="apaasCloud-title"> {{ textObj.casesText }} </h3>
            <!-- autoplay -->
            <Carousel
                v-model="activePartnerIndex"
                loop
                :autoplay-speed="5000"
                arrow="always"
                :height="500"
                :width="1100"
                class="dataConsult-partner-carousel"
                style="width: 1100px;margin:0 auto"
            >
                <CarouselItem
                    v-for="(swipeItem, index) in textObj.cases"
                    :key="index"
                >
                    <div class="dataConsult-partner-info">
                        <img
                            :src="swipeItem.image"
                            :alt="swipeItem.name"
                        >
                        <div class="dsh-padding100">
                            <h4>{{ swipeItem.name }}</h4>
                            <p v-html="swipeItem.content"></p>
                        </div>
                    </div>
                </CarouselItem>
            </Carousel>
        </div>

        <apaas-cloud-personal></apaas-cloud-personal>

    </div>
</template>

<script>
    import customizeModal from "../introduction/customizeModal.vue";
    import apaasCloudPersonal from "../apaasCloud/apaasCloudPersonal.vue";
    import { swiper, swiperSlide } from "vue-awesome-swiper";
    import "swiper/dist/css/swiper.css";
    export default {
        name: "dataConsult",
        components: {
            customizeModal, apaasCloudPersonal, swiper, swiperSlide
        },
        props: {
            type: {
                type: String,
                default: "firm"
            }
        },
        data () {
            return {
                activePartnerIndex: 0,
                activeBrightIndex: 0,
                firm: {
                    title: "投资项目管控数字化解决方案",
                    content: `明树基建投资项目管控数字化解决方案，
                                专为基建投资企业和城投公司量身打造，
                                涉及投资项目数据收集、审批、查询、测算、数据抽取、统计分析、风险防控各场景，
                                实现全生命周期的信息化、数字化和智能化管理，全面提升项目管控效率，
                                助力企业降本增效，提升投资收益，
                                降低投资风险，
                                最终助力企业实现整体战略目标。`,
                    subTitle: "为企业解决以下痛点",
                    mainImg: this.$imageSrcMap.introduction.firm.main,
                    row: [
                        { icon: this.$imageSrcMap.introduction.firm.shujv, name: "数据收集难、更新难" },
                        { icon: this.$imageSrcMap.introduction.firm.ziliao, name: "项目资料无汇总" },
                        { icon: this.$imageSrcMap.introduction.firm.guankong, name: "管控手段传统" },
                        { icon: this.$imageSrcMap.introduction.firm.zhibiao, name: "投资指标难监控" },
                        { icon: this.$imageSrcMap.introduction.firm.fengxian, name: "风险防控易滞后" },
                        { icon: this.$imageSrcMap.introduction.firm.juece, name: "投资决策无数据支撑" }
                    ],
                    brightText: "解决方案亮点",
                    bright: [
                        {
                            icon: this.$imageSrcMap.introduction.firm.zhouqi,
                            name: "覆盖项目全生命周期",
                            text: "全面涵盖从市场线索、投融资、项目建设、运营、管理、退出的所有链条，实现全过程数据收集分析、文件汇总和管控。",
                            image: this.$imageSrcMap.introduction.firm.firm_1
                        },
                        {
                            icon: this.$imageSrcMap.introduction.firm.xiaolv,
                            name: "全面提升协作效率",
                            text: "打通各部门流程与基础数据，实现数据和工作的自动、在线流转，所有过程标准化、可视化、数据化。",
                            image: this.$imageSrcMap.introduction.firm.firm_2
                        },
                        {
                            icon: this.$imageSrcMap.introduction.firm.baogao,
                            name: "台账、报告自动生成",
                            text: "通过预设规则和算法模型设计，实现各类台账表格、投资报告、重大项目跟踪周报等的在线自动生成，除保证数据实时可靠，更大幅降低的人员工作量，实现提质增效",
                            image: this.$imageSrcMap.introduction.firm.firm_3
                        },
                        {
                            icon: this.$imageSrcMap.introduction.firm.shuju,
                            name: "全局数据直观可视",
                            text: "实现所有数据的汇总和即时更新，建立统一数据库，并提供管理驾驶舱、核心指标统计看板、项目总览、项目进度图等，实现数据全面可视化",
                            image: this.$imageSrcMap.introduction.firm.firm_4
                        },
                        {
                            icon: this.$imageSrcMap.introduction.firm.yujing,
                            name: "实施预警，即时纠偏",
                            text: "通过对风险指标的设定，通过系统实现实时监控，及时发现风险点，并进行预警，使风险更早发现，更早介入，更早纠正",
                            image: this.$imageSrcMap.introduction.firm.firm_5
                        },
                        {
                            icon: this.$imageSrcMap.introduction.firm.touzi,
                            name: "投资决策清晰明确",
                            text: "基于全过程数据，实现投资项目的量化分析，并提供各个维度的统计分析数据，同时结合明树行业数据库数据，展示行业内项目情况，使决策有据可依",
                            image: this.$imageSrcMap.introduction.firm.firm_6
                        }

                    ],
                    casesText: "客户案例口碑",
                    cases: [
                        {
                            image: this.$imageSrcMap.introduction.firm.firm_koubei1,
                            name: "中建八局投建营一体化平台",
                            content: `中建八局投建营一体化平台，
                            为工程建设投资企业实现从投资、融资、建设到运营整个管理链条的打通，
                            促成工程建设投资企业投建营一体化商业模式落地。
                            平台通过固化管理标准与管理规范，使投建营管理工作标准化、规范化、流程化，
                            使管理落入实处，产生实效。
                            平台同时引入集约化管理思维，实现投建营人、财、物及各项目管理要素的集中管理，有效提升投建营一体化管控能力。<br/>
                            中建八局投建营一体化平台，
                            实现投资项目全生命周期的信息化、数字化和智能化管理，
                            建立起涵盖投资机会发现、投资项目评估、投资决策、融资管理、现金流管理、建设期管理和运营期管理的完整投融资管理体系，
                            提升投资收益，推动数字化转型`
                        },
                        {
                            image: this.$imageSrcMap.introduction.firm.firm_koubei2,
                            name: "杭州城投建设有限公司项目管理系统",
                            content: `基于明树自研aPaaS云平台，
                                        为PPP项目量身打造全过程投资管理系统，
                                        根据项目在投资、建设、运营中存在管理的问题，
                                        通过建立统一标准工作流，规范数据间的打通流转工作方式，提高管理效率。
                                        进而通过数据的规范化管理，加强对数据结果的分析利用，判断项目的可行性，产出项目的风险评估与一定的决策建议。`
                        },
                        {
                            image: this.$imageSrcMap.introduction.firm.firm_koubei3,
                            name: "中交公规院投资项目管理系统",
                            content: `该项目实现对项目的投资完成情况和合同执行进度进行数据化管理，
                                        主要内容为项目间数据的对比，包括注资数据、投资数据、回款数据等等，
                                        以及这些数据的累积值和年度值，展示各个阶段的数据情况，
                                        可以更清晰的看到投资完成情况，保障数据的可溯源性，同时也更方便对数据的查询矫正。
                                        同时根据设定的指标和实际数据对比，管理者可以随时了解到指标完成情况和项目资金情况，实现项目的全方位数字化管理。`
                        }
                    ],
                    team: {
                        address: "北京市朝阳区望京科技园F座5层502",
                        tel: "010-86203077",
                        email: "contacts@bridata.com"
                    }
                },
                gov: {
                    title: "政府投资项目数字化管理系统",
                    content: `明树数据政府投资项目数字化管理系统，
                                针对政府项目管理特点和需求，
                                利用现代科技手段建立区域项目统一数据库，
                                对区域内项目实施在线管理、督促催办、效能评估和信息服务。
                                围绕项目审批、建设推进、办结落实等节点进行跟踪，
                                实时查看项目数据、进展，
                                使管理更加科学、规范、高效、简便，
                                帮助政府降本增效，科学决策，实现管理数字化、智能化。
                            `,
                    subTitle: "为政府解决以下痛点",
                    mainImg: this.$imageSrcMap.introduction.gov.main,
                    row: [
                        { icon: this.$imageSrcMap.introduction.gov.zhangkong, name: "全局掌控能力不高" },
                        { icon: this.$imageSrcMap.introduction.firm.shujv, name: "数据收集难、有偏差" },
                        { icon: this.$imageSrcMap.introduction.firm.guankong, name: "管控手段传统" },
                        { icon: this.$imageSrcMap.introduction.gov.nanluoshi, name: "投资任务难落实" },
                        { icon: this.$imageSrcMap.introduction.firm.fengxian, name: "缺乏有效风险提醒" },
                        { icon: this.$imageSrcMap.introduction.gov.xiangmuduo, name: "项目多、人员少" }
                    ],
                    brightText: "解决方案亮点",
                    bright: [
                        {
                            icon: this.$imageSrcMap.introduction.gov.zhouqi_gov,
                            name: "项目全过程管理跟踪",
                            text: "系统通过对数据表和更新规则的设置，并接入各级使用人员及信息系统，实现数据的在线收集、定期更新、自动同步，减少人力成本",
                            image: this.$imageSrcMap.introduction.gov.gov_1
                        },
                        {
                            icon: this.$imageSrcMap.introduction.gov.shuju_gov,
                            name: "建立区域项目数据库",
                            text: "通过系统实现数据在线收集、更新，并进行分析、清洗，统一存储，形成区域项目数据库，所有数据汇总展示、随时可查",
                            image: this.$imageSrcMap.introduction.gov.gov_2
                        },
                        {
                            icon: this.$imageSrcMap.introduction.gov.baogao_gov,
                            name: "多种数据分析方式",
                            text: "对项目库中的数据，结合管理要求，进行多维度、多方式的展示，方便全方位了解项目情况，实时了解项目进展。同时，通过对数据的处理分析，将各项关键指标和维度的分析结果展示在系统首页，各方面数据一目了然。",
                            image: this.$imageSrcMap.introduction.gov.gov_3
                        },
                        {
                            icon: this.$imageSrcMap.introduction.gov.jinzhan_gov,
                            name: "投资进展实时掌控",
                            text: "通过系统实现各级投资任务的制定、下发、跟踪功能，支持投资计划和实际完成情况比对，投资完成进度，任务调整等功能，实时了解区域内投资任务完成情况，及时发现潜在风险，促进投资目标达成",
                            image: this.$imageSrcMap.introduction.gov.gov_4
                        },
                        {
                            icon: this.$imageSrcMap.introduction.gov.yujing_gov,
                            name: "项目风险预警体系",
                            text: "通过对各个阶段设置监控指标，进行指标权重、影响度的定义，并结合算法，对实际数据进行监控分析，实现全面的风险预警和防控，对合规性、进度、任务完成情况等进行实时风险评估，帮助更快的发现潜在风险。",
                            image: this.$imageSrcMap.introduction.gov.gov_5
                        },
                        {
                            icon: this.$imageSrcMap.introduction.gov.xiaolv_gov,
                            name: "全面提升协作效率",
                            text: "通过对日常工作的数字化、智能化，如数据自动收集、报告自动生成、数据自动分析、风险自动预警等功能的实现，并可实现对接上下级系统，实现数据自动传输填报，减轻政府管理难度，降低工作量，提高管理质量和工作效率。",
                            image: this.$imageSrcMap.introduction.firm.firm_2
                        }

                    ],
                    casesText: "客户案例口碑",
                    cases: [
                        {
                            image: this.$imageSrcMap.introduction.gov.gov_koubei1,
                            name: "湖北省项目全生命周期管理监测服务平台",
                            content: `为湖北省提供项目监测服务平台提供建设和运维服务，
                                        以项目库、政府机构库、社会资本库、咨询机构库、金融机构库、专家库、SPV库和资料库八大数据库为支撑，
                                        形成项目信息管理、日常工作管理、全口径统计分析、项目动态监控、中长期支出责任管理、项目绩效管理、信用管理和融资评估撮合八大管理子系统，
                                        以项目全流程监测与服务为出发点，以PPP项目全生命周期资产管理为核心，通过信息化、流程化及智能化进行管理创新。
                                        2019年，明树开发的湖北省PPP监测服务平台被国家发改委和国家信息中心评为全国示范PPP项目管理平台。
                                    `
                        },
                        {
                            image: this.$imageSrcMap.introduction.gov.gov_koubei2,
                            name: "深圳市政府和社会资本合作综合信息管理系统建设项目",
                            content: `本系统为国内唯一由财政和发改体系共同监管，
                                        由国资平台公司（特建发）直接管理的PPP 项目综合管理系统，
                                        明树数据结合自身aPaaS平台和行业实施经验，对客户的实际情况和个性化需求进行了充分调研，
                                        并进行方案的设计和适配，最终实现了满足数字化管理要求和深圳市管理规范的综合信息管理系统，
                                        实现了对项目全过程的监管和管控，为项目管理工作提质增效。`
                        },
                        {
                            image: this.$imageSrcMap.introduction.gov.gov_koubei3,
                            name: "新疆维吾尔自治区项目全生命周期管理监测服务平台",
                            content: `基于明树aPaaS平台，在国家发改委明确数据对接时间要求的情况下，
                                    明树数据团队和地方发改委紧密合作、加班加点，在不到一个月的时间内就完成了全部的数据梳理并成功完成和发改委的数据对接，
                                    实现了对全区项目全生命周期的数据收集和实施监测，并基于指标监测数据和算法分析，
                                    为项目风险的防范和项目管控决策提供支撑。`
                        },
                        {
                            image: this.$imageSrcMap.introduction.gov.gov_koubei4,
                            name: "大连甘井子区投资项目全生命周期数字化管理系统",
                            content: `大连甘井子区投资项目全生命周期数字化管理系统，
                                    围绕区域投资项目与投资任务监管需要，
                                    联动项目公司、街道办事处、横向委办局及市发改委各层级数据，
                                    实现数据的在线收集、更新、分析、统计、应用等场景，
                                    解决地区投资项目和投资任务监管难度大、监管任务重的问题。<br/>
                                    大连甘井子区投资项目全生命周期数字化管理系统，
                                    将政府对项目和投资工作的各项考核指标数字化，
                                    实现对辖区内投资项目的精细化管理，
                                    强化区域谋划储备和引进落地建设高质量项目的能力，
                                    并落实重大项目推进责任制，助力甘井子区发改委投资项目管理提质增效。
                                    `
                        }
                    ],
                    team: {
                        address: "北京市朝阳区望京科技园F座5层502",
                        tel: "010-86203077",
                        email: "contacts@bridata.com"
                    }
                },
                // 申请试用modal框
                showApplyModal: false,
                priFormData: {},
                operationMap: {
                    openModal: {
                        name: "定制专属解决方案",
                        event: "openApplyModal",
                        type: "openModal",
                        size: "large",
                        shape: "circle",
                        btnType: "primary",
                        class: "pink-btn"
                    }
                },
                swiperOption: {
                    loop: true,
                    direction: "vertical",
                    autoplay: true,
                    pagination: {
                        el: ".swiper-pagination",
                        clickable: true
                    },
                    speed: 1000
                }
            };
        },
        computed: {
            textObj () {
                return this.type === "firm" ? this.firm : this.gov;
            }
        },
        mounted () {
            setInterval(_ => {
                if (this.textObj.bright && this.activeBrightIndex < this.textObj.bright.length - 1) {
                    this.activeBrightIndex += 1;
                } else {
                    this.activeBrightIndex = 0;
                }
            }, 3000);
        },
        created () {},
        methods: {
            // 申请试用modal框
            openApplyModal () {
                this.showApplyModal = true;
                this.priFormData = {
                    project_type: this.type === "firm" ? "enterprise" : "government"
                };
            }
        }
    };
</script>



// WEBPACK FOOTER //
// src/views/introduction/dataConsult/dataConsult.vue